import {makeAutoObservable} from 'mobx';
import * as Api from '@/utils/api/api';

class Help {
    menuList = [];

    constructor() {
        makeAutoObservable(this)
    }

    /**
     * 初始化
     */
    init() {
        this.menuList = [];
    }

    /**
     * 获取菜单列表
     */
    async fetchMenuList() {
        try {
            let {list} = await Api.helpMenuList();

            let menuList = [];
            list.forEach(item => {
                if (!item.article) {
                    menuList.push(item);
                }
            });
            list.forEach(item => {
                if (item.article) {
                    menuList.push(item);
                }
            });

            this.menuList = menuList.map(item => {
                let {
                    id,
                    title,
                    name,
                    article: isArticle,
                    articles: articleList
                } = item;

                return {
                    id,
                    title: title || name,
                    isArticle,
                    articleList,
                    active: false
                };
            });
        } catch (error) {
        }
    }

    /**
     * 选择菜单
     * @param {*} param0
     */
    async selectMenu(index) {
        this.menuList[index].active = !this.menuList[index].active;
        // if (this.menuList[index].active) {
        //   this.menuList[index].active = false;
        // } else {
        //   this.menuList.forEach((item, i) => {
        //     if (index !== i) {
        //       item.active = false;
        //     } else {
        //       item.active = true;
        //     }
        //   });
        // }
    }
}

const store = new Help();

export default store;
